/*global
    jQuery, aap
*/
(function($) {

    'use strict';

    function limitText() {
        /*jshint validthis: true */
        var $this = $(this),
            limit = $this.data('limit'),
            $counter = $this.siblings('p').find('.count');

        if (this.value.length >= limit) {
            //gone over limit, cannot enter more and set counter to 0
            this.value = this.value.substring(0, limit);
            $counter.text('0');
            return;
        }
        //show remaining chars
        $counter.text(limit - this.value.length);

    }
    //event trigger
    $('textarea').keyup(aap.debounce(limitText, 500));
}(jQuery));
